import { Color, Radius, Spacing } from 'zens-storybook'
import { StyleSheet, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { useStore, WorkspaceTypeData, Draft, ApiError, useWorkspaceTypeMutation } from 'zens-store'
import { Suspense, useState } from 'react'
import { useRouter, useNumberParams } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { LayoutHeader, WorkspaceTypeForm } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    margin: Spacing.L,
    padding: Spacing.L,
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
  },
})

const WorkspaceTypeAdd = () => {
  const [errors, setErrors] = useState<Record<string, string>>()
  const [{ companyId }] = useNumberParams()
  const router = useRouter()
  const store = useStore()
  const { message } = store
  const { t } = useTranslation()
  const mutation = useWorkspaceTypeMutation()

  const breadcrumb = useBreadcrumb([
    {
      title: t('Workspace types'),
      href: { pathname: `/workspacetypes`, params: { companyId } },
    },
    {
      title: t('Create workspace type'),
    },
  ])

  const add = async (draft: Draft<WorkspaceTypeData>) => {
    try {
      setErrors({})
      await mutation.create(draft)
      message.add({
        message: t('Workspace type was created successfully'),
        status: 'success',
      })
    } catch (error) {
      const { message: errorMessage, fields } = error as ApiError
      console.debug(`WORKSPACE: Workspace type failed: ${errorMessage}`)
      if (fields) {
        setErrors(fields)
      } else {
        message.add({
          message: `${t('Workspace type could not be created')}. ${errorMessage}`,
          status: 'error',
        })
      }
      return
    }

    router.push({ pathname: `/workspacetypes`, params: { companyId } })
  }

  return (
    <View style={styles.container}>
      <LayoutHeader breadcrumb={breadcrumb} title={t('Create workspace type')} menu={undefined} />
      <View style={styles.content}>
        <Suspense fallback={<WorkspaceTypeForm.Skeleton />}>
          <WorkspaceTypeForm companyId={companyId} onSave={add} errors={errors} />
        </Suspense>
      </View>
    </View>
  )
}

export default WorkspaceTypeAdd
